import React from "react";
import WeaveLogo from "@/components/WeaveLogo";

export default function SiteFooter() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--line)] mt-32 bg-[var(--bg)]"
    >
      <div className="section-pad py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-7">
          <WeaveLogo height={36} />
          <h4 className="font-display text-2xl md:text-4xl max-w-2xl tracking-tight mt-6">
            Founder First. Business Second. <br />
            <span className="text-[var(--teal)]">A LinkedIn audit with soul.</span>
          </h4>
          <p className="mt-4 text-[var(--ink-2)] max-w-xl">
            Practical, human-centred support for founders building something that matters.
          </p>
        </div>
        <div className="md:col-span-5 text-sm text-[var(--muted)] grid grid-cols-2 gap-6">
          <div>
            <div className="overline mb-3">The Weave</div>
            <div className="space-y-1">
              <div>Innovation through connection</div>
              <div>Support that grows with you</div>
              <div>You don't have to build alone</div>
            </div>
          </div>
          <div>
            <div className="overline mb-3">© {new Date().getFullYear()}</div>
            <div>The Weave · Founder Brand Audit</div>
            <div className="mt-1">A community that cuts through the chaos.</div>
          </div>
        </div>
      </div>
    </footer>
  );
}
